/* istanbul ignore file */

/** This is a placeholder, not real render in dom */
const OptGroup = () => null;
OptGroup.isSelectOptGroup = true;
export default OptGroup;